import { render } from "./SpectreAdsTrap.vue?vue&type=template&id=620e648f&scoped=true"
import script from "./SpectreAdsTrap.vue?vue&type=script&lang=js"
export * from "./SpectreAdsTrap.vue?vue&type=script&lang=js"

import "./SpectreAdsTrap.vue?vue&type=style&index=0&id=620e648f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620e648f"]])

export default __exports__